
/**
 * Custom component for Back Bar default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-12-19 (1.0.0) (jhoward)
 *    - Add <back-bar-drinks-section> to extend <back-bar-default-section>.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <back-bar-drinks-section>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <back-bar-drinks-section>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import BackBarDefaultSection from "./BackBarDefaultSection.vue";

export default defineComponent({
  components: {
    BackBarDefaultSection,
  },
  name: "BackBarDrinksSection",
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
